import { object, string } from 'yup';

export default object().shape({
  placa: string().required('* Campo obrigatório!'),
  // Quantidade de faturamentos permitidos; só é exigida quando o toggle está ligado.
  numero_faturamento_temporario: string().when('faturamento_temporario', {
    is: '1',
    then: (schema) =>
      schema
        .required('* Campo obrigatório!')
        .matches(/^[1-9]\d*$/, '* Informe um número inteiro maior que zero'),
  }),
})
